import React from "react";
import { Portal } from "@reach/portal";
import Loader from ".";

interface LoaderFullScreenProps {
  show: boolean;
  loaderSize?: "sm" | "md" | "lg" | "xl";
}

const LoaderFullScreen: React.FC<LoaderFullScreenProps> = ({
  show = true,
  loaderSize = "lg",
}) => {
  if (!show) return null;

  return (
    <Portal>
      <div className="fixed inset-0 top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
        <Loader size={loaderSize} />
      </div>
    </Portal>
  );
};

export default LoaderFullScreen;
